import { DATA_METRICS } from '../componentKeys.js'

const identifiers = {
  key: 'inboundCalls',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'Inbound Calls',
  },
}

const keys = {
  statKey: 'inbound_calls',
  componentKeys: [DATA_METRICS],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'aggregate',
}

const inboundCalls = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { inboundCalls }
